import React from "react";
import logo from "../../assets/images/vcare/vcare_logo.jpg";
import { imageCodes, textCodes, titleCodes } from "../../template_codes/vcare/home_page_codes";

function Home() {
    return (
        <div>
            {/*             slider section            */}
            <div className="carousel w-full">
                <div id="slide1" className="carousel-item relative w-full">
                    <img src={imageCodes.slider1.image} className="w-full" />
                    <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide2" className="btn btn-circle w-4 h-4">❮</a>
                        <a href="#slide2" className="btn btn-circle w-4 h-4">❯</a>
                    </div>
                </div>
                <div id="slide2" className="carousel-item relative w-full">
                    <img src={imageCodes.slider2.image} className="w-full" />
                    <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide1" className="btn btn-circle w-4 h-4">❮</a>
                        <a href="#slide1" className="btn btn-circle w-4 h-4">❯</a>
                    </div>
                </div>
            </div>
            {/*             end of slider section            */}

            {/*           categories section                */}
            <div className="w-full pt-16">
                <h1 className="text-center font-semibold text-xl">{titleCodes.categories.title}</h1>
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-8 pt-8 lg:px-24 xl:px-24 px-4">

                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/?cat=cough_and_cold">
                            <img src={imageCodes.cate1.image} alt="Cough and Cold" width={180} height={120} className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Cough And Cold</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/?cat=fame_products">
                            <img src={imageCodes.cate1.image} alt="FAME Products" width={180} height={120} className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Eye Care</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/?cat=eye_care">
                            <img src={imageCodes.cate1.image} alt="Eye Care" width={180} height={120} className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">FAME Products</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/?cat=multivitamin_and_minerals">
                            <img src={imageCodes.cate1.image} alt="GI care" width={180} height={120} className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">GI care</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/?cat=%E1%80%80%E1%80%95%E1%80%BA%E1%80%81%E1%80%BD%E1%80%AC_%E1%80%A1%E1%80%99%E1%80%BB%E1%80%AD%E1%80%AF%E1%80%B8%E1%80%99%E1%80%BB%E1%80%AD%E1%80%AF%E1%80%B8">
                            <img src={imageCodes.cate1.image} alt="Mother & Baby Care" width={180} height={120} className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Mother & Baby Care</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/?cat=lozenges_(_%E1%80%84%E1%80%AF%E1%80%B6%E1%80%86%E1%80%B1%E1%80%B8%E1%80%A1%E1%80%99%E1%80%BB%E1%80%AD%E1%80%AF%E1%80%B8%E1%80%99%E1%80%BB%E1%80%AD%E1%80%AF%E1%80%B8_)">
                            <img src={imageCodes.cate1.image} alt="Multivitamin and minerals" width={180} height={120} className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Multivitamin and minerals</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/?cat=mother_&_baby_care">
                            <img src={imageCodes.cate1.image} alt="ကပ်ခွာ အမျိုးမျိုး" width={180} height={120} className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">ကပ်ခွာ အမျိုးမျိုး</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/?cat=gi_care">
                            <img src={imageCodes.cate1.image} alt="Lozenges ( ငုံဆေးအမျိုးမျိုး )" width={180} height={120} className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Lozenges ( ငုံဆေးအမျိုးမျိုး )</p>
                        </a>
                    </div>
                </div>
            </div>
            {/*           end of categories section                */}


            {/*           multivitamin and minerals section                */}
            <div className="container w-full pt-16">
                <h1 className="text-center font-semibold text-xl">{titleCodes.multiVita.title}</h1>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-6 2xl:grid-cols-6 pt-8 px-4">
                    <div className="border m-1">
                        <a href="https://vcaremm.com/product/cl7vvtac023842301s6sdcsypjf" target="_blank">
                            <img src={imageCodes.multi1.image} alt="Oramin-F" width={300} height="180" className="phover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Oramin-F</p>
                        </a>
                    </div>
                    <div className="border m-1">
                        <a href="https://vcaremm.com/product/cl7x9n58x1713901s6swopht53" target="_blank">
                            <img src={imageCodes.multi2.image} alt="Becoactin Syrup | 100 ml" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Becoactin Syrup | 100 ml</p>
                        </a>
                    </div>
                    <div className="border m-1">
                        <a href="https://vcaremm.com/product/cl7ywv9gl5947701s6lgiu12i7" target="_blank">
                            <img src={imageCodes.multi3.image} alt="Immunactiv" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Immunactiv</p>
                        </a>
                    </div>
                    <div className="border m-1">
                        <a href="https://vcaremm.com/product/cl7vvr6t723705001s6t81f1b9h" target="_blank">
                            <img src={imageCodes.multi4.image} alt="Oramin-G" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Oramin-G</p>
                        </a>
                    </div>
                    <div className="border m-1">
                        <a href="https://vcaremm.com/product/cl7kbuys47100501s6t3e98ohl" target="_blank">
                            <img src={imageCodes.multi5.image} alt="Appeton Infants Drops" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Appeton Infants Drops</p>
                        </a>
                    </div>
                    <div className="border m-1">
                        <a href="https://vcaremm.com/product/cl7t5n6p98720001s64ln66uin" target="_blank">
                            <img src={imageCodes.multi6.image} alt="Supradyn Enegy" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Supradyn Enegy</p>
                        </a>
                    </div>
                </div>
            </div>
            {/*           end of multivitamin and minerals section                */}


            {/*           mom & baby section                */}
            <div className="container w-full pt-16">
                <h1 className="text-center font-semibold text-[#004987] text-xl">{titleCodes.mombabycare.title}</h1>
                <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 pt-8 lg:px-24 xl:px-24 px-4">
                    <div className="border m-1">
                        <a href="https://vcaremm.com/product/cl7ywu6c15881401s6xuuga5xx" target="_blank">
                            <img src={imageCodes.momb1.image} alt="Bab Syrup | 100 ml" width={300} height="180" className="phover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Bab Syrup | 100 ml</p>
                        </a>
                    </div>
                    <div className="border m-1">
                        <a href="https://vcaremm.com/product/cl7vw64av24393201s6jyyyalnt" target="_blank">
                            <img src={imageCodes.momb2.image} alt="Obimin Multivitamins" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Obimin Multivitamins</p>
                        </a>
                    </div>
                    <div className="border m-1">
                        <a href="https://vcaremm.com/product/cl7vuctwf21395501s69i36n9v8" target="_blank">
                            <img src={imageCodes.momb3.image} alt="Sara for Children Paracetamol Oral Suspension" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Sara for Children Paracetamol Oral Suspension</p>
                        </a>
                    </div>
                    <div className="border m-1">
                        <a href="https://vcaremm.com/product/cl7ywdord5427201s6bhpm3n7w" target="_blank">
                            <img src={imageCodes.momb4.image} alt="Sara for Children Paracetamol Oral Suspension" width={300} height="180" className="hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="py-4 text-center">Biogesic Syrup</p>
                        </a>
                    </div>
                </div>
            </div>
            {/*           end of new arrivals section                */}

            {/*           choose reason section                */}
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 px-4 pt-20">
                <div className="md:px-10">
                    <img src={imageCodes.choose.image} className="hover:-translate-y-4 duration-300 ..."></img>
                </div>
                <div className="w-full">
                    <h1 className="text-xl lg:text-2xl xl:text-3xl font-semibold md:pr-0 pt-10 lg:pt-0 xl:pt-10">{titleCodes.reasons.title}</h1>
                    <div>
                        <ul className="py-14 lg:py-4 xl:py-14">
                            <li className="mb-4">
                                <div className="flex">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="text-cyan-500"
                                        width="1.9em" height="1.9em" preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 24 24"><path fill="currentColor"
                                            d="M8.434 20.566c1.335 0 2.591-.52 3.535-1.464l7.134-7.133a5.008 5.008 0 0 0-.001-7.072a4.969 4.969 0 0 0-3.536-1.463c-1.335 0-2.59.52-3.534 1.464l-7.134 7.133a5.01 5.01 0 0 0-.001 7.072a4.971 4.971 0 0 0 3.537 1.463zm5.011-14.254a2.979 2.979 0 0 1 2.12-.878c.802 0 1.556.312 2.122.878a3.004 3.004 0 0 1 .001 4.243l-2.893 2.892l-4.242-4.244l2.892-2.891z" /></svg>
                                    <div className="pl-4">
                                        <h1 className="text-zinc-900">{textCodes.reason1.text}</h1>
                                        <p className="text-gray-500 text-sm pt-2">{textCodes.rs1.text}</p>
                                    </div>
                                </div>

                            </li>
                            <li className="mb-4">
                                <div className="flex">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="text-cyan-500"
                                        width="2em" height="2em" preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 24 24"><path fill="currentColor"
                                            d="M8.434 20.566c1.335 0 2.591-.52 3.535-1.464l7.134-7.133a5.008 5.008 0 0 0-.001-7.072a4.969 4.969 0 0 0-3.536-1.463c-1.335 0-2.59.52-3.534 1.464l-7.134 7.133a5.01 5.01 0 0 0-.001 7.072a4.971 4.971 0 0 0 3.537 1.463zm5.011-14.254a2.979 2.979 0 0 1 2.12-.878c.802 0 1.556.312 2.122.878a3.004 3.004 0 0 1 .001 4.243l-2.893 2.892l-4.242-4.244l2.892-2.891z" /></svg>
                                    <div className="pl-4">
                                        <h1 className="text-zinc-900">{textCodes.reason2.text}</h1>
                                        <p className="text-gray-500 text-sm pt-2">{textCodes.rs2.text}</p>
                                    </div>
                                </div>

                            </li>
                            <li className="">
                                <div className="flex">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="text-cyan-500"
                                        width="2em" height="2em" preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 24 24"><path fill="currentColor"
                                            d="M8.434 20.566c1.335 0 2.591-.52 3.535-1.464l7.134-7.133a5.008 5.008 0 0 0-.001-7.072a4.969 4.969 0 0 0-3.536-1.463c-1.335 0-2.59.52-3.534 1.464l-7.134 7.133a5.01 5.01 0 0 0-.001 7.072a4.971 4.971 0 0 0 3.537 1.463zm5.011-14.254a2.979 2.979 0 0 1 2.12-.878c.802 0 1.556.312 2.122.878a3.004 3.004 0 0 1 .001 4.243l-2.893 2.892l-4.242-4.244l2.892-2.891z" /></svg>
                                    <div className="pl-4">
                                        <h1 className="text-zinc-900">{textCodes.reason3.text}</h1>
                                        <p className="text-gray-500 text-sm pt-2">{textCodes.rs3.text}</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {/*           end of choose reason section                */}

            {/*           fame product section                */}
            <div className="container w-full pt-16">
                <h1 className="text-center font-semibold text-[#004987] text-xl">{titleCodes.fame.title}</h1>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-6 2xl:grid-cols-6 pt-8 px-2">
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/product/cl7k0bwi31742201s6l65to0az" target="_blank">
                            <img src={imageCodes.fame1.image} alt="FAME Bee Pollen Capsule" className="my-2 hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="text-sm pt-4 text-center">FAME Bee Pollen Capsule</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/product/cl7k1gjws2532001s6qqb8xmil" target="_blank">
                            <img src={imageCodes.fame2.image} alt="FAME Rejuvir Cap" className="my-2 hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="text-sm pt-4 text-center">FAME Rejuvir Cap</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/product/cl7k5b9v5584501s6mpykd7gf" target="_blank">
                            <img src={imageCodes.fame3.image} alt="FAME Arthrotec Cap" className="my-2 hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="text-sm pt-4 text-center">FAME Arthrotec Cap</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/product/cl7k8ssw71385901s6iexyu71w" target="_blank">
                            <img src={imageCodes.fame4.image} alt="FAME Nonicap Cap 60s" className="my-2 hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="text-sm pt-4 text-center">FAME Nonicap Cap 60s</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/product/cl7k5tauc1966301s67emq41fc" target="_blank">
                            <img src={imageCodes.fame5.image} alt="FAME SawPalmetto 60tab Bot" className="my-2 hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="text-sm pt-4 text-center">FAME SawPalmetto 60tab Bot</p>
                        </a>
                    </div>
                    <div className="border m-1 border-current">
                        <a href="https://vcaremm.com/product/cl7k96bqr163201s6rgi3a98x" target="_blank">
                            <img src={imageCodes.fame6.image} alt="FAME Nature C Tab" className="my-2 hover:-translate-y-1 duration-300 ..."></img>
                            <hr />
                            <p className="text-sm pt-4 text-center">FAME Nature C Tab</p>
                        </a>
                    </div>
                </div>
            </div>
            {/*           end of fame product section                */}

        </div>
    );
}

export default Home;